// routes/post-type-archive-stockist

import Promise from "promise-polyfill";
var Flickity = require("flickity");

export default {
    init() {
        if (!window.promise) {
            window.Promise = Promise;
        }

        import("../util/map").then(function (Map) {
            var map;

            if (window.isMapInit === true) {
                map = new Map.default();
            } else {
                document.addEventListener("map-init", function () {
                    console.log("event");
                    map = new Map.default();
                });
            }
        });
        if (document.querySelector(".online-stockists_slide")) {
            var online_stockists = new Flickity(".online-stockists_slide", {
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 60,
                    y2: 50,
                    x3: 60,
                },
            });
        }
        if (document.querySelector(".supermarkets-retailers_slide")) {
            var spmkt_stockists = new Flickity(
                ".supermarkets-retailers_slide",
                {
                    autoPlay: true,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 60,
                        y2: 50,
                        x3: 60,
                    },
                }
            );
        }
    },
    finalize() {},
};



// WEBPACK FOOTER //
// ./js/routes/post-type-archive-stockist.js